import { useSelector } from 'react-redux'
import { getPropertyById } from '../redux/selectors'
import { PropertyDetails } from '../types/properties'

export const usePropertyById = (propertyId?: string): PropertyDetails | undefined =>
  useSelector(getPropertyById)(propertyId)
